module.exports = __webpack_public_path__ + "static/img/AA-2.cafd942c.png";